import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Glyphicon } from 'react-bootstrap';

import CargomaticInput from 'components/v2/input';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

class SaveFilterModal extends Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    let name = '';
    this.state = {
      name: props.filterSelected ? props.selectedFilter.name : '',
    };
  }

  handleNameChange = (value) => this.setState({ name: value });

  render() {
    const { t } = this.props;
    return (
      (<Modal
        style={{ top: '30%' }}
        show={this.props.show}
        onHide={this.props.onHide}
      >
        <Modal.Body data-testid="ModalBody-3156f737">
          <fieldset data-testid="fieldset-8d9c731f">
            <h5 data-testid="h5-b7e48a17" className="text-grey-dark">{t('FILTER_SETTINGS')}</h5>
            <div data-testid="div-b593569c" className="flex">
              <div data-testid="div-1949821f" className="w-full mt-2">
                <CargomaticInput
                  dataTestId="CargomaticInput-c2d8d388"
                  maxLength={45}
                  label={titleize(t('NAME'))}
                  info={t('FILTER_NAME_INFO')}
                  placeholder={t('FILTER_NAME')}
                  value={this.state.name}
                  onChange={this.handleNameChange} />
              </div>
            </div>
            {this.props.canShareWithTeam && (
              <div data-testid="div-27decb76" className="py-4">
                <div data-testid="div-38b107b5" className="flex">
                  <div
                    data-testid="div-accb3649"
                    className="p-2 bg-green items-center text-white leading-none lg:rounded-full flex lg:inline-flex"
                    role="alert">
                    <span
                      data-testid="span-4e80690c"
                      className="flex rounded-full bg-green uppercase px-2 py-1 text-sm font-bold pr-1">
                      {t('PRO_TIP')}
                    </span>
                    <Glyphicon className="pr-2 text-xsm" glyph="pencil" />
                    <span data-testid="span-58f501e9">{t('SHARING_FILTER_MSG')}</span>
                  </div>
                </div>
                <div data-testid="div-ceacc7fa" className="mt-2">
                  <Glyphicon className="text-sm text-grey-dark" glyph="share" />
                  <span data-testid="span-d374edf0" className="mx-2 text-grey-dark">
                    {titleize(t('SHARE'))}
                  </span>
                  <input
                    data-testid="input-b9386949"
                    type="checkbox"
                    checked={this.props.share}
                    onChange={this.props.setShareWithTeam} />
                </div>
              </div>
            )}
          </fieldset>
        </Modal.Body>
        <Modal.Footer data-testid="ModalFooter-277b112a">
          <div data-testid="div-cc385977">
            <div data-testid="div-524c4ba2" className="flex justify-end">
              <button
                data-testid="button-c5438b39"
                onClick={this.props.onHide}
                className="button button-hollow-red mr-2">
                {t('CANCEL')}
              </button>
              {this.props.filterSelected &&
                this.props.selectedFilter.canEdit && (
                  <button
                    data-testid="button-0e29cdfc"
                    onClick={() => this.props.onUpdate(this.state.name)}
                    className="button button-hollow-green mr-2">
                    {titleize(t('UPDATE'))}
                  </button>
                )}
              <button
                data-testid="button-cd19e3e7"
                onClick={() => this.props.onSave(this.state.name)}
                className="button button-green">
                {titleize(t('SAVE'))}
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>)
    );
  }
}

export default withTranslation()(SaveFilterModal);
